import { render, staticRenderFns } from "./SelectQuestion.vue?vue&type=template&id=2cf5d115&scoped=true&"
import script from "./select-question.js?vue&type=script&lang=js&"
export * from "./select-question.js?vue&type=script&lang=js&"
import style0 from "./select-question.scss?vue&type=style&index=0&id=2cf5d115&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf5d115",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf5d115')) {
      api.createRecord('2cf5d115', component.options)
    } else {
      api.reload('2cf5d115', component.options)
    }
    module.hot.accept("./SelectQuestion.vue?vue&type=template&id=2cf5d115&scoped=true&", function () {
      api.rerender('2cf5d115', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Builder/Questions/SelectQuestion/SelectQuestion.vue"
export default component.exports